export default __webpack_public_path__ + "static/media/BALTIMORE.01836cee.jpg";